/** Locked microcopy per UX-DR11 — do not paraphrase. */
export const bankExtractionCopy = {
  dropzoneHeadline: "Drag and drop your document here, or click to browse",
  dropzoneHelper: "Supported: PDF, JPG, PNG, DOCX · max 10 MB.",
  fileSizeError: "Files must be 10 MB or smaller — try a lower-resolution scan or split into pages",
  fileTypeError: "Supported file types: PDF, JPG, PNG, DOCX",
  attachValidation: "Please attach a document",
  processingHeadline: "Analyzing your document",
  processingSubtext: "This usually takes a few seconds",
  processingSteps: [
    "Uploading document...",
    "Extracting wire information...",
    "Validating bank information...",
    "Preparing preview screen",
  ] as const,
  prefillBanner: (filename: string) =>
    `We pre-filled this form from ${filename}. Please review every field before submitting. Fields with low confidence are highlighted in amber. Look for the ⚠ icon to see what was auto-filled.`,
  lowConfidenceTooltip: "Low confidence — please verify against your document.",
  missingFieldHelper: "Could not extract — please enter manually.",
  ambiguousTooltip: "This document had more than one possible value — please confirm.",
  ambiguousAnnounce: "Choice options shown.",
  confidenceLegendHigh: "High",
  confidenceLegendReview: "Review",
  methodMismatch: (detected: string) => `This document looks like a ${detected} document. Switch to ${detected} →`,
  totalFailureHeadline: "We couldn't extract wire details from this document.",
  totalFailureHeadlineWithMethod: (method: string) =>
    `Couldn't read the bank details from this document, but it looks like a ${method} document — try a clearer scan or enter your ${method} wire details manually.`,
  totalFailureSubtext:
    "We couldn't read the bank details from your document. This can happen with low-quality scans, password-protected files, or documents that don't clearly show wire instructions.",
  totalFailureBullets: [
    "Make sure the document is a clear PDF, JPG, PNG, or DOCX",
    "Remove password protection before uploading",
    "Ensure beneficiary name, bank, ABA/routing, and account number are clearly visible",
  ] as const,
  tryAnotherDocument: "TRY ANOTHER DOCUMENT",
  fillInManually: "FILL IN MANUALLY",
  editedBadge: "Edited",
  ariaHighConfidence: "Pre-filled from your document. High confidence.",
  ariaLowConfidence: "Pre-filled from your document. Low confidence — please verify.",
  ariaMissing: "Could not extract — please enter manually.",
} as const;

export const BANNED_VOCABULARY = [
  "AI",
  "machine learning",
  "model",
  "best guess",
  "extraction confidence score",
  "AI confidence",
  "we think",
] as const;

export const BANK_EXTRACTION_MAX_FILE_BYTES = 10 * 1024 * 1024;

export const BANK_EXTRACTION_ALLOWED_TYPES = new Set(["application/pdf", "image/png", "image/jpeg"]);
